import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import Sidebar from '../components/Sidebar';
import Page from '../components/Page';

import reactNotifGif from '../assets/react-notifs.gif';
import realertGif from '../assets/realert.gif';

const Portfolio = () => {
  const projects = [
    {
      title: 'react-awesome-notifications',
      description: `A beautiful fully customizable
         React + Redux notification system built with styled-components`,
      url: 'https://github.com/zakariaharti/react-awesome-notifications',
      img: reactNotifGif
    },
    {
      title: 'react-hookedup',
      description: `A collection of useful React hooks`,
      url: 'https://github.com/zakariaharti/react-hookedup'
    },
    {
      title: 'falconql',
      description: `Universal Full-Stack React GraphQL Boilerplate:
         Koa, TypeORM, Webpack, TypeScript, Apollo,
         Redux, HMR, SSR, SASS/LESS, CSSNext, Styled-Components, SEO`,
      url: 'https://github.com/zakariaharti/falconql'
    },
    {
      title: 'realert',
      description: `Sweet simple JavaScript alert alternative
         for React built with styled-components`,
      url: 'https://github.com/zakariaharti/realert',
      img: realertGif
    },
    {
      title: 'tercelx',
      description: `Isomorphic MERN Stack Boilerplate with TypeScript, SSR,
         HMR, Redux, Routing, Lazy loading,
         i18n, Styled-components, Postcss, Cssnext, Webpack and many more`,
      url: 'https://github.com/zakariaharti/tercelx'
    },
    {
      title: 'boa.js',
      description: `Node.js CLI utility helper`,
      url: 'https://github.com/zakariaharti/boa'
    },
    {
      title: 'react-typescript-boilerplate',
      description: `A React + TypeScript + Webpack boilerplate for libraries`,
      url: 'https://github.com/zakariaharti/react-typescript-boilerplate-for-libraries'
    },
  ];

  return (
    <Layout title="Zakaria Harti" description="ml">
      <Sidebar isIndex={false} />
      <Page>
        <h2 className="about-h2">Portfolio</h2>
        <hr />
        <div>
          {projects.map(project => (
            <div className="project-container" key={project.title}>
              <a target="blanc" href={project.url}><h3>{project.title}</h3></a>
              <p>{project.description}</p>
              { project.img && <img src={project.img} alt="img" style={
                {
                  border: '1px solid #e73371'
                }
              } /> }
            </div>
          ))}
          <div className="more">
            <a href="http://github.com/zakariaharti">more on GitHub</a>
          </div>
        </div>
      </Page>
    </Layout>
  );
};

export default Portfolio;
